import { Reducer } from "redux";

import { DisciplineTemplateNotesResponse } from "../models/Api/Notes";
import { DisciplineTemplateListNotesListDispatchTypes } from "../models/DispatchTypes/Notes";
import { MasterDisciplineTemplateNotesListActionDispatchTypes } from "../constants/Notes";

export const initialState: DisciplineTemplateNotesResponse = {
  loading: false,
  response: [],
};

const MasterDisciplineTemplateNotesListReducer: Reducer<
  DisciplineTemplateNotesResponse,
  DisciplineTemplateListNotesListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterDisciplineTemplateNotesListActionDispatchTypes.DISCIPLINE_NOTES_TEMPLATE_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterDisciplineTemplateNotesListActionDispatchTypes.DISCIPLINE_NOTES_TEMPLATE_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterDisciplineTemplateNotesListReducer;
